<p-table [value]="measurements" dataKey="id">
  <ng-template pTemplate="caption">
    <div class="p-d-flex">
      <p-selectButton [options]="types" [(ngModel)]="selectedType" optionLabel="name" (onChange)="changeType()"></p-selectButton>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th style="max-width: 3rem"></th>
      <th>Name</th>
      <th pSortableColumn="category.name">Type <p-sortIcon field="category.name"></p-sortIcon>
      </th>
      <th>Value</th>
      <th>Is Active</th>
      <th>Is Default</th>
      <th>Is Enabled</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-uom let-i="rowIndex" let-expanded="expanded">
    <tr class="parentRow">
      <td class="action">
        <button type="button" [pRowToggler]="uom" pButton pRipple class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="uom.childUOM.length > 0"
          style="width: 20px;height: 20px;"></button>
      </td>
      <td>{{uom.name}} ({{uom.code}})</td>
      <td>{{uom.category?uom.category.name:''}}</td>
      <td></td>
      <td>{{uom.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.NO}}</td>
      <td>
        <p-radioButton [disabled]="uom.statusId==statusConstants.INACTIVE" [value]="true" [(ngModel)]="uom.isDefault"
          (onClick)="eventCalled(uom,'default')"></p-radioButton>
        <span>{{uom.isDefault?answertypeConstants.Yes:answertypeConstants.No}}</span>
      </td>
      <td class="p-text-left">
        <p-inputSwitch [(ngModel)]="uom.isEnable" (onChange)="eventCalled(uom,'enabled')"
        [disabled]="uom.isDefault || uom.statusId==statusConstants.INACTIVE"></p-inputSwitch>
      </td>
      <td class="action">
        <span class="btnBars p-mr-0" (click)="showAddRelatedUOM(uom)" pTooltip="Add" tooltipPosition="top"><i
            class="pi pi-plus"></i></span>
        <span class="btnBars p-mr-0" (click)="checkUOM(uom)" *ngIf="!uom.isDefault && uom.childUOM.length<1 && uom.createdSource!=uomConstants.SystemGenerated" pTooltip="Delete"
          tooltipPosition="top"><i class="pi pi-trash"></i></span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-uom>
    <ng-container *ngFor="let child of uom.childUOM">
      <tr>
        <td></td>
        <td style="padding-left: 2rem !important;">{{child.name}} ({{child.code}})</td>
        <td>{{uom.category?uom.category.name:''}}</td>
        <td>{{child.value}}</td>
        <td>{{child.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
        <td>{{child.isDefault?answertypeConstants.Yes:answertypeConstants.No}}</td>
        <td></td>
        <td class="action">
          <span class="btnBars p-mr-0" (click)="showEditUOM(child)" pTooltip="Edit" tooltipPosition="top"><i
              class="pi pi-pencil"></i></span>
          <span class="btnBars p-mr-0" (click)="checkUOM(uom,child)" pTooltip="Delete" tooltipPosition="top"><i
              class="pi pi-trash"></i></span>
        </td>
      </tr>
    </ng-container>
  </ng-template>
</p-table>

<p-dialog header="{{addEditUOMHeader}}" [(visible)]="displayAddUOM" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <form [formGroup]="UOMForm">
    <div class="header">
      <h5>UOM Information
        <p-inputSwitch class="header-switch" formControlName="statusId"
          [disabled]="UOMForm.controls['isDefault'].value"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <label>Type <span style="color: red;">*</span></label>
          <p-dropdown [options]="UOMTypes" formControlName="categoryId" optionLabel="name"
            placeholder="Select Types" appendTo="body" (onChange)="getBaseUOMByType($event,0)"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-6">
          <label>Base UOM</label>
          <p-dropdown [options]="baseUomDD" formControlName="baseUOMId" optionLabel="name"
            placeholder="Select Base Uom" appendTo="body" (onChange)="addOtherUom($event)"></p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayAddUOM=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton [disabled]="!UOMForm.valid" (click)="showAddUOM2(UOMForm.value)"
      label="Next"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{addEditUOMHeader}}" [(visible)]="displayAddUOM2" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <form [formGroup]="UOMForm">
    <div class="header">
      <h5>UOM Information
        <p-inputSwitch class="header-switch" formControlName="statusId"
          [disabled]="UOMForm.controls['isDefault'].value" (onChange)="checkUOMProduct()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <label>Type <span style="color: red;">*</span></label>
          <p-dropdown [options]="UOMTypes" formControlName="categoryId" optionLabel="name"
            appendTo="body" [disabled]="true"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-6" *ngIf="!isEdit && !addrelatedBaseUOM">
          <label>Base UOM</label>
          <p-dropdown [options]="baseUomDD" formControlName="baseUOMId" optionLabel="name"
            appendTo="body" [disabled]="true"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-6" *ngIf="isEdit || addrelatedBaseUOM">
          <label>Base UOM</label>
          <input type="text" pInputText [(ngModel)]="baseUOMName" [ngModelOptions]="{standalone: true}" [readOnly]="true">
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-5"  *ngIf="!isEdit">
          <label>Related UOM</label>
          <p-dropdown [options]="relatedUomDD" formControlName="relatedBaseUOMId" optionLabel="name"
            placeholder="Select Related Uom" appendTo="body"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-5" *ngIf="isEdit">
          <label>Related UOM</label>
          <input type="text" pInputText [(ngModel)]="relatedUOMName" [ngModelOptions]="{standalone: true}" [readOnly]="true">
        </div>
        <div class="p-col-12 p-md-2">
          <label class="p-mt-6">Is Equal to</label>
        </div>
        <div class="p-col-12 p-md-5" *ngIf="isEdit">
          <label># of {{baseUOMName}}</label>
          <input type="text" pInputText formControlName="value">
        </div>
        <div class="p-col-12 p-md-4" *ngIf="!isEdit">
          <label># of {{(!isEdit && !addrelatedBaseUOM)?(UOMForm.controls['baseUOMId'].value && UOMForm.controls['baseUOMId'].value.name):baseUOMName}}</label>
          <input type="text" pInputText formControlName="value">
        </div>
        <div class="p-col-12 p-md-1" *ngIf="!isEdit">
          <button type="button" pButton icon="pi pi-plus" style="float: right; margin-top: 2.5rem;" 
            (click)="addItem(UOMForm.value)" [disabled]="!(UOMForm.controls['relatedBaseUOMId'].value && UOMForm.controls['value'].value)"></button>
        </div>
      </div>
      <p-table [value]="conversionLists" editMode="row" dataKey="id" *ngIf="!isEdit">
        <ng-template pTemplate="header">
          <tr>
            <th>Related UOM</th>
            <th># of {{(!isEdit && !addrelatedBaseUOM)?(UOMForm.controls['baseUOMId'].value && UOMForm.controls['baseUOMId'].value.name):baseUOMName}}</th>
            <th style="width: 2rem;">
              <p-checkbox binary="true" [(ngModel)]="headerCheck" [ngModelOptions]="{standalone: true}"
                (onChange)="selectDeselectAll(headerCheck)"></p-checkbox>
            </th>
            <th style="width: 4rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-i="rowIndex">
          <tr>
            <td pEditableColumn class="action">
              {{product.name}}
            </td>
            <td pEditableColumn class="action">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input pInputText type="text" [(ngModel)]="product.value" [ngModelOptions]="{standalone: true}">
                </ng-template>
                <ng-template pTemplate="output">
                  {{product.value}}
                </ng-template>
              </p-cellEditor>
            </td>
            <td>
              <p-checkbox [value]="product" [(ngModel)]="product.checked" binary="true"
                [ngModelOptions]="{standalone: true}"></p-checkbox>
            </td>
            <td class="action">
              <span class="btnBars p-mt-0" *ngIf="product.checked" (click)="deleteFormula(i)"><i
                  class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton *ngIf="!isEdit && !addrelatedBaseUOM" (click)="backUOM()" label="Back" class="p-button-secondary"></button>
    <button type="button" pButton (click)="displayAddUOM2=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton  [disabled]="UOMForm.invalid || (!isEdit && !conversionLists?.length)" (click)="saveUOM(UOMForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{addEditUOMHeader}}" [(visible)]="displayAddOtherUOM" [modal]="true" [responsive]="true"
  [style]="{width: '45vw'}">
  <form [formGroup]="addNewForm">
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <label>Name</label>
          <input type="text" pInputText formControlName="name">
        </div>
        <div class="p-col-12 p-md-6">
          <label>Abbrevation</label>
          <input type="text" pInputText formControlName="code">
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="displayAddOtherUOM=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton [disabled]="!addNewForm.valid" (click)="saveOtherUom(addNewForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{action}} UOM" [(visible)]="displayUOMAvailability" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="header">
      <h5>{{action}} Warning</h5>
    </div>
    <div class="card">
      <span style="font-weight: bold;">This UOM is associated with below Multiple Products</span><br>
      <span>{{associatedUOM}}</span>
    </div>
</p-dialog>
